import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea0e9500"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pointer-events-none fixed inset-0 flex items-start justify-end px-4 py-6 sm:p-6" }
const _hoisted_2 = { class: "w-full max-w-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Notification = _resolveComponent("Notification")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_TransitionGroup, {
          appear: "",
          tag: "div",
          "enter-active-class": 
          _ctx.getNotificationsCount > 1
            ? 'transform ease-out delay-200 duration-200 transition'
            : 'transform ease-out duration-200 transition'
        ,
          "enter-from-class": "translate-x-4 opacity-0",
          "enter-to-class": "translate-x-0 opacity-100",
          "leave-active-class": "transition ease-in duration-100",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0",
          "move-class": "transition ease-in-out duration-300"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getNotifications, (notification, idx) => {
              return (_openBlock(), _createBlock(_component_Notification, {
                key: notification.id,
                notification: notification,
                class: _normalizeClass(idx > 0 ? 'mt-4' : '')
              }, null, 8, ["notification", "class"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["enter-active-class"])
      ])
    ]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 64))
}